import Service from "../../AuthService";
const SettingSocialSecurity = {
    getSocialSecurity() {
        return Service.get("/setting_social_security");
    },
    showSocialSecurity(id) {
        return Service.get("/setting_social_security/" + id);
    },
    updateSocialSecurity(id, data) {
        return Service.put("/setting_social_security/" + id, data);
    },
    createSocialSecurity(data) {
        return Service.post("/setting_social_security", data);
    },
    deleteSocialSecurity(id) {
        return Service.delete("/setting_social_security/" + id);
    },

    //rate tax
    getRateTaxPerson(page){
        return Service.get(`setting_tax_person?page=${page}`)
    },
    showRateTaxPerson(id){
        return Service.get(`setting_tax_person/${id}`)
    },
    createRateTaxPerson(data){
        return Service.post(`setting_tax_person`,data)
    },
    updateRateTaxPerson(id,data){
        return Service.put(`setting_tax_person/${id}`,data)
    },
    deleteTaxPerson(id) {
        return Service.delete(`setting_tax_person/${id}`);
    }
};
export default SettingSocialSecurity;
